import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "top-menu",
  data: function data() {
    return {
      itemHome: {
        name: '首页',
        source: 'el-icon-menu'
      },
      activeIndex: "0",
      items: []
    };
  },
  inject: ["index"],
  created: function created() {
    this.getMenu();
  },
  computed: _objectSpread({}, mapGetters(["tagCurrent", "menu"])),
  methods: {
    openHome: function openHome(itemHome) {
      this.index.openMenu(itemHome);
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          name: itemHome.name,
          src: ''
        }, {})
      });
    },
    openMenu: function openMenu(item) {
      this.index.openMenu(item);
    },
    getMenu: function getMenu() {
      var _this = this;

      this.$store.dispatch("GetTopMenu").then(function (res) {
        _this.items = res;
      });
    },
    generateTitle: function generateTitle(item) {
      return this.$router.$avueRouter.generateTitle(item.name, (item.meta || {}).i18n);
    }
  }
};